export default "__VITE_ASSET__Dq_TeOS6__"